import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * CRA + React Router: restore scroll on navigation so footer / in-app links
 * don't leave the viewport stuck at the old scroll position (e.g. deep on /shop).
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');
      requestAnimationFrame(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          window.scrollTo(0, 0);
        }
      });
      return;
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}
